import {API_URL, apiPost} from '../api'

export const postApprove = async (id: string, signer: string = '') => {
    return await apiPost(API_URL, 'admin/crypto/withdraw/approve', {id: id, signer: signer})
}
